import { styled } from 'styled-components';
import ArrowUp from '@/shared/assets/arrow-circle-up.svg';
import { Button } from '@/shared/ui/form/button';
import Clock from '@/shared/assets/clock.svg';

const ArrowUpIcon = styled(ArrowUp)`
  transform: rotate(180deg);

  path {
    fill: ${({ $active }) => ($active ? '#fff' : '#AFAFAF')};
  }
`;

const ClockIcon = styled(Clock)`
  path {
    fill: ${({ $active }) => ($active ? '#fff' : '#AFAFAF')};
  }
`;

const ArrowBottomIcon = styled(ArrowUpIcon)`
  transform: rotate(360deg);
`;

const WalletButton = styled(Button)`
  border-radius: 8px;
  gap: 4px;
  cursor: pointer;

  @media (max-width: 768px) {
    gap: 0px;
    height: 40px;
  }
`;

export { ArrowBottomIcon, ArrowUpIcon, WalletButton, ClockIcon };
